import React from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from '@components/Button/Button';
import styles from './ModalHelp.module.scss';

interface ModalHelpProps {
    handleCancel: () => void;
}

const ModalHelp: React.FC<ModalHelpProps> = ({ handleCancel }) => {
    
    
    
    return (
        <>
            <Modal show onHide={handleCancel} centered >
                <div className="modalCustom">
                    <h3 className='text-center'>Números de Contacto</h3>

                    <div className={styles.phoneBox}>
                        <div className={styles.phoneNumber}>
                            Santiago +569 9630 3068
                        </div>
                        <div className={styles.phoneNumber}>
                            Concepción +569 9630 5175
                        </div>
                        <div className={styles.phoneNumber}>
                            Contact Center 600 006 0020
                        </div>
                    </div>

                    <div className={`modalCustom-buttons ${styles.buttons}`}>
                        <Button
                            label="Cerrar"
                            type="primary"
                            icon="close"
                            iconPosition="left"
                            handleClick={handleCancel}
                        />
                    </div>
                </div>
            </Modal>
        </>
    );
};

export default ModalHelp;
